import './tab.css';

const markup = `<db:tab>
	<h4 data-id='header' class='tab-header'>
		<span data-id='name' data-property='innerHTML'></span>
	</h4>
	<div data-id='content'></div>
</db:tab>`;

export default DomClass(markup, function Tab() {
	var _t = this;

	this.header.onclick = () => this.select();

	this.select = function() {
		on(_t.parentNode, 'selectTab').fire(_t);
	};

	this.deselect = function() {
		on(_t.parentNode, 'selectTab').fire(null);
	};

	this.handleSelect = function() {
		this.__dom.header.classList.add('selected');
		this.classList.add('selected');
		if (this.content.load) this.content.load();
		on(this, 'select').fire();
	};

	this.handleDeselect = function() {
		this.__dom.header.classList.remove('selected');
		this.classList.remove('selected');
		on(this, 'deselect').fire()
	};

	on(this.parentNode, 'selectTab').then(tab => {
		if (tab == _t) {
			_t.handleSelect();
		} else {
			_t.handleDeselect();
		}
	});

	// TODO: try to figure out why this is the way it is and make it
	// NOT depend on a timeout...
	setTimeout(function() {
		var all = getNodes(_t.parentNode, 'db:tab');
		var first = all[0];
		_t.parentNode.insertBefore(_t.__dom.header, first);
	}, 1);

});
